import "./App.css";
import Home from "./components/Home.tsx";
import AvisoPrivacidad from "./components/avisoPrivacidad.tsx";
import Soporte from "./components/Soporte.tsx";
import { Routes, Route } from "react-router";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="avisoPrivacidad" element={<AvisoPrivacidad />} />
      <Route path="soporte" element={<Soporte />} />
    </Routes>
  );
}

export default App;
